function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E3CA5",
  d: "M10.425 18.244c.619 2.287 2.831 4.012 3.937 3.956.038 0 4.238-.787 6.525-4.631 1.782-2.981 1.182-5.869-1.256-5.944-.844.075-10.387 2.269-9.206 6.619m9-14.644a10.58 10.58 0 00-6.92-2.55c-1.537 0-3 .338-4.331.919a3.73 3.73 0 00-.675.337c-.15.075-.3.169-.45.244l.037.019c-.43.3-.825.656-1.125 1.069-3.056 4.03 7.2 6.974 12.694 6.993 2.531 1.8 3.244-5.118.769-7.031z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5493F7",
  d: "M8.794 3.675C7.387 5.794 2.68 7.294 1.912 7.05c.038-.056.057-.131.094-.188.263-.525.581-1.012.919-1.481.338-.469.713-.9 1.125-1.313.413-.412.844-.787 1.313-1.125.28-.206.58-.412.9-.6a3.29 3.29 0 011.556-.412c2.081.056.994 1.725.975 1.744M7.631 18.656c.094.675 0 3.3-.131 3.525-.112 0-.356.019-1.069-.375-.375-.206-.731-.45-1.069-.694-.468-.337-.9-.712-1.312-1.125a10.766 10.766 0 01-1.125-1.312 13.306 13.306 0 01-.919-1.482 8.65 8.65 0 01-.675-1.612c-.168-.563-.337-1.144-.431-1.725a11.92 11.92 0 01-.15-1.838 11.102 11.102 0 01.581-3.542l.113-.338c.806 1.088 1.744 2.063 2.55 3.15.768 1.031 1.8 2.738 2.025 3.094 1.312 2.231 1.518 3.619 1.612 4.275m15.619-6.638c0 1.462-.281 2.85-.788 4.125-1.33 1.425-10.256-2.082-10.35-2.12-1.218-.524-4.93-2.155-5.268-4.705-.488-3.694 6.994-6.263 10.275-6.357.393 0 1.593.019 2.287.582 2.363 2.08 3.844 5.1 3.844 8.474m-6.038 9.976c-.974.45-2.043.13-1.762-.825.525-1.82 5.213-3.694 6.244-3.788.131-.019.187.075.131.169-1.106 1.893-2.7 3.45-4.613 4.444"
});

function SvgTerra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra);
export default __webpack_public_path__ + "static/media/Terra.0f1584c5.svg";
export { ForwardRef as ReactComponent };